import React, { ReactNode } from 'react';
import cx from 'classnames';

import { cardHeight, cardWidth } from '../constants';

interface CardWrapperProps {
    addClasses?: string;
    children: ReactNode;
    id?: string;
}

export const CardWrapper = ({
    addClasses,
    children,
    id,
}: CardWrapperProps): JSX.Element => (
    <div
        className={cx('rounded-lg bg-white m-2', addClasses)}
        style={{ height: cardHeight, width: cardWidth }}
        id={id}
    >
        {children}
    </div>
);
